const paragraph = (text) => ({
  type: "paragraph",
  children: [{ text }],
});

const list = (items) => ({
  type: "list",
  children: items.map((text) => ({
    children: [{ text }],
  })),
});

const informationSecurityContent = {
  MainHeading: "Information Security Policy",
  TextSection: [
    {
      id: 1,
      Title: "Introduction",
      Content: [
        paragraph(
          "Clover Bay Technologies is committed to ensuring the highest standards of information security in our products, services, and operations. This statement outlines our intent, principles, and governance for protecting the confidentiality, integrity, and availability of information entrusted to us."
        ),
      ],
    },
    {
      id: 2,
      Title: "Our Security Promise",
      Content: [
        paragraph(
          "We safeguard the confidentiality, integrity, and availability of organizational and customer information through a robust and continuously improving Information Security Management System (ISMS) aligned with ISO 27001:2022."
        ),
        paragraph("We ensure:"),
        list([
          "Protection of information from unauthorized access or disclosure",
          "Reliability and resilience of systems and services",
          "Accuracy and integrity of data across all operations",
        ]),
      ],
    },
    {
      id: 3,
      Title: "Why Information Security Matters",
      Content: [
        paragraph("Our ISMS is designed to address:"),
        list([
          "Rising global cybersecurity threats and sophisticated attacks",
          "Sensitivity and criticality of information handled for our customers",
          "Applicable legal, regulatory, and contractual obligations across regions",
          "Due-diligence expectations from customers, partners, and stakeholders",
          "The need for secure working practices among employees, contractors, and suppliers",
        ]),
        paragraph("We ensure individuals:"),
        list([
          "Work in a safe and secure environment",
          "Perform responsibilities without compromising sensitive information",
          "Access, process, and manage data securely at all times",
        ]),
      ],
    },
    {
      id: 4,
      Title: "Policy Statement",
      Content: [
        paragraph(
          "Clover Bay is committed to establishing, implementing, maintaining, and continually improving an Information Security Management System that supports business objectives while meeting all relevant legal, contractual, and compliance requirements."
        ),
      ],
    },
    {
      id: 5,
      Title: "Our Commitments",
      Content: [
        list([
          "Protect confidentiality, integrity, and availability of information",
          "Maintain trust through secure and compliant service delivery",
          "Apply risk-based, proportionate security controls",
          "Continuously strengthen our overall security posture",
        ]),
      ],
    },
    {
      id: 6,
      Title: "Leadership and Commitment",
      Content: [
        paragraph(
          "Clover Bay Senior Management supports the ISMS through:"
        ),
        list([
          "Clear information security objectives aligned with business goals",
          "Integration of security into decisions, culture, and daily operations",
          "Provision of necessary resources and organizational support",
          "Promotion of awareness and accountability across all personnel",
          "Oversight of timely risk mitigation and security improvements",
          "Ensuring the ISMS consistently achieves its intended outcomes",
        ]),
      ],
    },
    {
      id: 7,
      Title: "High-Level Objectives",
      Content: [
        list([
          "Embed secure practices through continuous training and awareness",
          "Strengthen customer trust by safeguarding their information",
          "Maintain resilient systems that ensure business continuity",
        ]),
      ],
    },
    {
      id: 8,
      Title: "Scope Statement",
      Content: [
        paragraph(
          "The ISMS applies to all information assets, supporting technologies, business processes, and services related to the design, development, delivery, and support of Clover Bay's secure solutions."
        ),
        paragraph("This includes:"),
        list([
          "All Clover Bay employees, contractors, and authorized third parties",
          "All company locations and infrastructure under operational control",
          "All environments where Clover Bay information is accessed, processed, stored, or transmitted",
        ]),
      ],
    },
    {
      id: 9,
      Title: "Policy Applicability",
      Content: [
        paragraph("This policy applies to:"),
        list([
          "All Clover Bay-owned or managed information and systems",
          "All digital and physical assets used to process information",
          "All employees, contractors, vendors, partners, and stakeholders with access to Clover Bay information",
          "All customer information processed by Clover Bay",
        ]),
      ],
    },
    {
      id: 10,
      Title: "Information Security Risk Management",
      Content: [
        paragraph("We take a proactive, risk-based approach to security."),
        paragraph("We:"),
        list([
          "Identify and assess risks to information confidentiality, integrity, and availability",
          "Apply protections based on sensitivity and business impact",
          "Continually adapt to evolving threats and regulatory changes",
          "Ensure risk decisions are approved at appropriate leadership levels",
        ]),
        paragraph(
          "This enables secure and trusted operations for our customers and stakeholders."
        ),
      ],
    },
    {
      id: 11,
      Title: "Information Security Awareness & Communication",
      Content: [
        paragraph(
          "We foster a strong security culture by ensuring all personnel:"
        ),
        list([
          "Understand their security responsibilities",
          "Receive appropriate training and awareness",
          "Actively contribute to safeguarding systems and data",
        ]),
      ],
    },
    {
      id: 12,
      Title: "Supplier & Third-Party Security",
      Content: [
        paragraph(
          "We ensure partners and suppliers maintain high security standards."
        ),
        paragraph("We:"),
        list([
          "Define clear information security requirements in agreements",
          "Monitor and validate security performance throughout engagements",
          "Manage ICT supply chain risks to safeguard critical information",
          "Protect shared data end-to-end across our extended ecosystem",
        ]),
      ],
    },
    {
      id: 13,
      Title: "Contact Information",
      Content: [
        paragraph(
          "For questions or reporting concerns related to Information Security: **contactus@cloverbaytechnologies.com**"
        ),
      ],
    },
  ],
};

export default informationSecurityContent;
